module.exports = __webpack_public_path__ + "static/media/home_excavator.aee8fd79.png";